import {FormattedMessage} from "react-intl"

export function LandingHeaderFamilyTime() {
    return (
        <div className="family-time">

            {/* OWN FAMILIES */}
            <p><FormattedMessage id="landing.slider.card3.families"/></p>

            {/* SHARING */}
            <img src="https://cdn.gedcomcreator.com/assets/family-time.png" alt="Family time"/>
            <p>
                <FormattedMessage id="landing.slider.card3.time" values={{ break: <br/> }}/>
                <span><FormattedMessage id="landing.slider.card3.matters"/></span>
            </p>
        </div>
    )
}